import React, { useState } from "react";
import axios from 'axios';
import './NewLeadForm.css';

const ImportLeads = () => {
    const [file, setFile] = useState(null);
    const [leadSource, setLeadSource] = useState('Call');
    const [leadStatus, setLeadStatus] = useState('New');
    const [assignedTo, setAssignedTo] = useState('everyone');
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if(!file) { alert("Please select a file first."); return; }

        setUploading(true);
        try {
            const token = localStorage.getItem("token");
            const formData = new FormData();
            formData.append('file', file);
            formData.append('lead_source', leadSource);
            formData.append('lead_status', leadStatus);
            formData.append('assigned_to_type', assignedTo);

            const res = await axios.post('https://skcapi.btcjapan.co/import_leads.php', formData, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });

            if (res.data.success) {
                alert(res.data.message);
                setFile(null);
                e.target.reset();
            } else {
                alert(res.data.error || "Import failed.");
            }
        } catch (err) {
            console.error(err);
            alert("Error uploading file. Please try again.");
        } finally {
            setUploading(false);
        }
    };

    const downloadSample = () => {
        const sample = "Lead Title,Lead Name,Email,Phone,Address,City,State,Country\nExample Lead,John Doe,john@example.com,1234567890,123 Street,New York,NY,USA\n";
        const blob = new Blob([sample], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sample_leads.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="leads-import-container" style={{ padding: "20px 160px" }}>
            <div className="import-hero">
                <div>
                    <div className="import-eyebrow">
                        <span className="eyebrow-dot"></span>
                        IMPORT LEADS
                    </div>
                    <h2>Import Leads from Excel</h2>
                    <p>Upload your leads file to quickly import multiple customers.</p>
                </div>
                <button className="download-sample-btn" onClick={downloadSample} style={{ minHeight: 40, padding: '0 18px', border: 0, borderRadius: 10, background: 'linear-gradient(135deg, #5750d6, #443cc2)', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
                    Download Sample
                </button>
            </div>

            <div className="form-section-card">
                <form onSubmit={handleUpload}>
                    <div className="import-form-group">
                        <label>Choose File <span className="required">*</span></label>
                        <div className="import-input-wrapper">
                            <input type="file" accept=".csv, .xls, .xlsx" onChange={handleFileChange} />
                        </div>
                    </div>

                    <div className="import-form-group">
                        <label>Lead Source</label>
                        <select value={leadSource} onChange={(e) => setLeadSource(e.target.value)}>
                            <option>Call</option>
                            <option>Facebook</option>
                            <option>Instagram</option>
                            <option>Google</option>
                            <option>WhatsApp</option>
                            <option>X (Twitter)</option>
                            <option>Email</option>
                            <option>Website</option>
                        </select>
                    </div>

                    <div className="import-form-group">
                        <label>Lead Status</label>
                        <select value={leadStatus} onChange={(e) => setLeadStatus(e.target.value)}>
                            <option>New</option>
                            <option>Contacted</option>
                            <option>Qualified</option>
                            <option>Converted</option>
                            <option>Lost</option>
                        </select>
                    </div>

                    <div className="import-form-group" style={{alignItems:'flex-start'}}>
                        <label>Assigned To <span className="required">*</span></label>
                        <div className="assigned-radio-group">
                            <label className="assigned-radio-option permission-choice" style={{ width: 'auto', padding: '8px 12px', border: '1px solid #dedff5', borderRadius: '9px', background: '#f9f9ff', cursor: 'pointer' }}>
                                <input type="radio" name="importAssign" value="everyone" checked={assignedTo === 'everyone'} onChange={(e) => setAssignedTo(e.target.value)} />
                                <span><strong>Everyone</strong></span>
                            </label>
                            <label className="assigned-radio-option permission-choice" style={{ width: 'auto', padding: '8px 12px', border: '1px solid #dedff5', borderRadius: '9px', background: '#f9f9ff', cursor: 'pointer' }}>
                                <input type="radio" name="importAssign" value="customize" checked={assignedTo === 'customize'} onChange={(e) => setAssignedTo(e.target.value)} />
                                <span><strong>Customize Permission</strong></span>
                            </label>
                        </div>
                    </div>

                    <button type="submit" className="import-submit-btn" disabled={uploading}>
                        {uploading ? 'Uploading...' : 'Upload'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ImportLeads;